"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledFluidContainer = exports.StyledContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _excluded = ["fluid", "xlarge"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledContainer = exports.StyledContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1xokdtg-0"
})(["margin-right:auto;margin-left:auto;padding-left:", ";padding-right:", ";&:before{content:' ';display:table;}&:after{content:' ';display:table;clear:both;}@media ", "{&{width:", ";}}@media ", "{&{width:", ";}}@media ", "{&{width:", ";}}@media ", "{&{width:", ";}}", ""], function (props) {
  return props.theme.gutter;
}, function (props) {
  return props.theme.gutter;
}, function (props) {
  return props.theme.responsive.small;
}, function (props) {
  return props.theme.device.small;
}, function (props) {
  return props.theme.responsive.medium;
}, function (props) {
  return props.theme.device.medium;
}, function (props) {
  return props.theme.responsive.large;
}, function (props) {
  return props.theme.device.large;
}, function (props) {
  return props.theme.responsive.large;
}, function (props) {
  return props.theme.device.large;
}, function (props) {
  return props.$xlarge && (0, _ykbStyledComponents.css)(["@media ", "{&{width:", ";}}"], function (props) {
    return props.theme.responsive.xlarge;
  }, function (props) {
    return props.theme.device.xlarge;
  });
});
var StyledFluidContainer = exports.StyledFluidContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1xokdtg-1"
})(["margin-right:auto;margin-left:auto;padding-left:", ";padding-right:", ";&:before{content:' ';display:table;}&:after{content:' ';display:table;clear:both;}"], function (props) {
  return props.theme.gutter;
}, function (props) {
  return props.theme.gutter;
});
var Container = exports.default = /*#__PURE__*/function (_Component) {
  function Container() {
    (0, _classCallCheck2.default)(this, Container);
    return _callSuper(this, Container, arguments);
  }
  (0, _inherits2.default)(Container, _Component);
  return (0, _createClass2.default)(Container, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        fluid = _this$props.fluid,
        xlarge = _this$props.xlarge,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return fluid ? /*#__PURE__*/_react.default.createElement(StyledFluidContainer, (0, _extends2.default)({}, rest, {
          theme: theme,
          $xlarge: xlarge
        })) : /*#__PURE__*/_react.default.createElement(StyledContainer, (0, _extends2.default)({}, rest, {
          theme: theme,
          $xlarge: xlarge
        }));
      });
    }
  }]);
}(_react.Component);
Container.displayName = 'Container';
Container.propTypes = {
  className: _propTypes.default.string,
  fluid: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  xlarge: _propTypes.default.bool
};
Container.defaultProps = {
  className: ''
};